import type { LuminaSubAgentResponseType, SUB_AGENTS } from '../types';

export const getSubAgentData = (
	sub_agents_data: LuminaSubAgentResponseType[],
	sub_agent_name: SUB_AGENTS,
) => sub_agents_data.find((sub_agent) => sub_agent.sub_agent_name === sub_agent_name);
